var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComb1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50402 3.47729C5.86603 2.8409 4.83164 2.8409 4.19365 3.47729C3.96012 3.71022 3.89755 4.04911 4.00594 4.33883C3.9872 4.35422 3.96902 4.37065 3.9515 4.38813L2.21873 6.11654C1.92546 6.40906 1.92546 6.88333 2.21873 7.17586C2.51199 7.46838 2.98746 7.46838 3.28072 7.17586L5.0135 5.44745L5.68415 6.1163L3.95158 7.84451C3.65832 8.13703 3.65832 8.61131 3.95158 8.90383C4.24484 9.19635 4.72032 9.19635 5.01358 8.90383L6.74615 7.17562L7.41693 7.84471L5.68425 9.57302C5.39098 9.86555 5.39098 10.3398 5.68425 10.6323C5.97751 10.9249 6.45298 10.9249 6.74624 10.6323L8.47893 8.90403L9.14952 9.57293L7.41703 11.3011C7.12377 11.5936 7.12377 12.0678 7.41703 12.3604C7.7103 12.6529 8.18577 12.6529 8.47903 12.3604L10.2115 10.6323L10.8823 11.3013L9.1497 13.0296C8.85644 13.3221 8.85644 13.7964 9.1497 14.0889C9.44296 14.3814 9.91844 14.3814 10.2117 14.0889L11.9443 12.3607L20.3662 20.7614C20.6852 21.0795 21.2024 21.0795 21.5214 20.7614C22.1594 20.125 22.1594 19.0932 21.5214 18.4568L6.50402 3.47729Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComb1);
export default __webpack_public_path__ + "static/media/comb-1.9bcf76ee0396069660d9bb44054c01cf.svg";
export { ForwardRef as ReactComponent };